/* 130R — LP das empresas (/pages/oficinas-e-lojas): formulário de cadastro (sections/r130-lp-cadastro.liquid).
   - CNPJ: máscara, dígito verificador no navegador (o numérico e o alfanumérico da IN RFB 2.229/2024) e consulta
     pública na BrasilAPI para preencher razão social, cidade e UF. Se a consulta falhar, a pessoa preenche à mão.
   - WhatsApp: máscara (11) 91234-5678 e conferência do DDD.
   - Envio: valida; monta a Mensagem B da seção (uma informação por linha, linha vazia some) com o chassi salvo
     no aparelho; abre o WhatsApp; dispara 'r130:lead-b2b' {tipo, origem}; e deixa o formulário de contato nativo
     do Shopify seguir na mesma aba (vira e-mail para a loja, com as etiquetas lead-b2b e tipo:…).
   - Depois do envio (?contact_posted=true): o botão "Abrir o WhatsApp" reabre a mesma mensagem.
   Os dados ficam no sessionStorage só até a página seguinte (para reabrir a mensagem ou refazer o formulário). */
(function () {
  'use strict';
  var API = 'https://brasilapi.com.br/api/cnpj/v1/';
  var CHAVE = 'r130_lp_envio';
  var ICO = {
    alerta: '<path d="M12 3 2 21h20z"/><path d="M12 10v5M12 18h.01"/>',
    check: '<path d="M20 6 9 17l-5-5"/>',
    busca: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>'
  };
  function ico(nome) { return '<svg class="r130-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + ICO[nome] + '</svg>'; }
  function lerSessao() { try { return JSON.parse(sessionStorage.getItem(CHAVE) || 'null'); } catch (e) { return null; } }
  function gravarSessao(v) { try { if (v) sessionStorage.setItem(CHAVE, JSON.stringify(v)); else sessionStorage.removeItem(CHAVE); } catch (e) {} }
  function chassiSalvo() { try { var v = JSON.parse(localStorage.getItem('r130_chassi') || 'null'); return v && v.vin ? String(v.vin) : ''; } catch (e) { return ''; } }

  /* ---------- CNPJ ---------- */
  function cnpjLimpo(s) { return String(s || '').toUpperCase().replace(/[^0-9A-Z]/g, ''); }
  function cnpjDv(base) {
    // Pesos de 2 a 9, da direita para a esquerda; cada caractere vale o código ASCII menos 48 (0-9 = 0-9, A = 17…).
    var soma = 0, peso = 2;
    for (var i = base.length - 1; i >= 0; i--) { soma += (base.charCodeAt(i) - 48) * peso; peso = peso === 9 ? 2 : peso + 1; }
    var r = soma % 11;
    return r < 2 ? 0 : 11 - r;
  }
  function cnpjValido(s) {
    var c = cnpjLimpo(s);
    if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(c) || /^(.)\1{13}$/.test(c)) return false;
    var d1 = cnpjDv(c.slice(0, 12));
    var d2 = cnpjDv(c.slice(0, 12) + d1);
    return c.slice(12) === String(d1) + String(d2);
  }
  function cnpjMascara(s) {
    var c = cnpjLimpo(s).slice(0, 14), o = c.slice(0, 2);
    if (c.length > 2) o += '.' + c.slice(2, 5);
    if (c.length > 5) o += '.' + c.slice(5, 8);
    if (c.length > 8) o += '/' + c.slice(8, 12);
    if (c.length > 12) o += '-' + c.slice(12);
    return o;
  }

  /* ---------- WhatsApp ---------- */
  function foneLimpo(s) {
    var d = String(s || '').replace(/\D/g, '').replace(/^0+/, '');
    if (d.length > 11 && d.indexOf('55') === 0) d = d.slice(2).replace(/^0+/, '');
    return d.slice(0, 11);
  }
  function foneValido(s) {
    var d = foneLimpo(s);
    if (!/^[1-9][1-9]\d{8,9}$/.test(d)) return false;
    return d.length === 11 ? d.charAt(2) === '9' : /[2-5]/.test(d.charAt(2));
  }
  function foneMascara(s) {
    var d = foneLimpo(s);
    if (!d) return '';
    if (d.length <= 2) return '(' + d;
    var o = '(' + d.slice(0, 2) + ') ', n = d.slice(2);
    if (n.length <= 4) return o + n;
    var corte = d.length === 11 ? 5 : 4;
    return o + n.slice(0, corte) + '-' + n.slice(corte);
  }
  function emailValido(s) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(s || '').trim()); }

  // Reaplica a máscara sem jogar o cursor para o fim quando a pessoa edita no meio.
  function mascarar(campo, fmt, sig) {
    var v = campo.value, pos = campo.selectionStart == null ? v.length : campo.selectionStart;
    var novo = fmt(v);
    if (novo === v) return;
    var antes = sig(v.slice(0, pos)).length, noFim = pos === v.length;
    campo.value = novo;
    if (noFim || document.activeElement !== campo) return;
    var i = 0, n = 0;
    while (i < novo.length && n < antes) { if (sig(novo.charAt(i))) n++; i++; }
    try { campo.setSelectionRange(i, i); } catch (e) {}
  }
  function soDigitos(s) { return String(s || '').replace(/\D/g, ''); }

  function tituloCidade(s) {
    var minus = { da: 1, de: 1, do: 1, das: 1, dos: 1, e: 1 };
    return String(s || '').toLowerCase().split(/\s+/).map(function (p, i) {
      return i > 0 && minus[p] ? p : p.charAt(0).toUpperCase() + p.slice(1);
    }).join(' ');
  }

  function iniciar(form) {
    var cfgEl = form.querySelector('[data-r130-lp-cfg]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) {}
    var txt = cfg.txt || {};
    var salvo = lerSessao();

    /* ---------- depois do envio ---------- */
    var ok = form.querySelector('[data-r130-lp-ok]');
    if (ok) {
      var btn = ok.querySelector('[data-r130-lp-ok-wa]');
      if (btn && salvo && salvo.url) btn.href = salvo.url;
      if (salvo) gravarSessao({ url: salvo.url });   // os dados do formulário saem; fica só a mensagem
      try { ok.focus({ preventScroll: true }); } catch (e) {}
      return;
    }

    var q = function (k) { return form.querySelector('[data-r130-lp-campo="' + k + '"]'); };
    var c = { cnpj: q('cnpj'), razao: q('razao'), cidade: q('cidade'), uf: q('uf'), fone: q('fone'), email: q('email'), procura: q('procura') };
    var radios = Array.prototype.slice.call(form.querySelectorAll('[data-r130-lp-campo="tipo"]'));
    var opcoes = form.querySelector('[data-r130-lp-opcoes]');
    var status = form.querySelector('#r130-lp-cnpj-status');
    var resumo = form.querySelector('[data-r130-lp-resumo]');
    var troca = form.querySelector('[data-r130-lp-troca]');
    var mkt = form.querySelector('[data-r130-lp-mkt]');
    var mktValor = form.querySelector('[data-r130-lp-mkt-valor]');
    var tags = form.querySelector('[data-r130-lp-tags]');
    var msgCampo = form.querySelector('[data-r130-lp-msg]');
    var botao = form.querySelector('[data-r130-lp-enviar]');
    if (!c.cnpj || !botao) return;

    form.setAttribute('novalidate', '');

    // Voltou com erro do Shopify: refaz o formulário com o que a pessoa tinha digitado.
    if (form.querySelector('[data-r130-lp-erro-envio]') && salvo && salvo.campos) {
      Object.keys(c).forEach(function (k) { if (c[k] && salvo.campos[k] != null && !c[k].value) c[k].value = salvo.campos[k]; });
      radios.forEach(function (r) { r.checked = r.getAttribute('data-tipo') === salvo.campos.tipo; });
      if (mkt) mkt.checked = !!salvo.campos.mkt;
    }
    gravarSessao(null);

    /* ---------- mensagens por campo ---------- */
    function erroEl(k) { return form.querySelector('#r130-lp-' + k + '-erro'); }
    function mostrarErro(k, msg) {
      var el = erroEl(k);
      if (k === 'tipo') {
        if (opcoes) opcoes.classList.toggle('is-erro', !!msg);
        radios.forEach(function (r) { if (msg) r.setAttribute('aria-invalid', 'true'); else r.removeAttribute('aria-invalid'); });
      } else if (c[k]) {
        if (msg) c[k].setAttribute('aria-invalid', 'true'); else c[k].removeAttribute('aria-invalid');
      }
      if (!el) return;
      el.innerHTML = msg ? ico('alerta') + '<span></span>' : '';
      if (msg) el.lastChild.textContent = msg;
      el.hidden = !msg;
    }
    function mostrarStatus(estado, msg) {
      if (!status) return;
      status.hidden = !msg;
      status.setAttribute('data-estado', estado || '');
      status.innerHTML = msg ? ico(estado === 'ok' ? 'check' : estado === 'busca' ? 'busca' : 'alerta') + '<span></span>' : '';
      if (msg) status.lastChild.textContent = msg;
    }
    function tipoMarcado() { for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i]; return null; }

    function erroDe(k) {
      var v = c[k] ? String(c[k].value || '').trim() : '';
      switch (k) {
        case 'cnpj': return !v ? txt.obrigatorio : (cnpjValido(v) ? '' : txt.cnpj);
        case 'razao': case 'cidade': return v ? '' : txt.obrigatorio;
        case 'uf': return v ? '' : (txt.uf || txt.obrigatorio);
        case 'tipo': return tipoMarcado() ? '' : (txt.tipo || txt.obrigatorio);
        case 'fone': return !v ? txt.obrigatorio : (foneValido(v) ? '' : txt.fone);
        case 'email': return !v ? txt.obrigatorio : (emailValido(v) ? '' : txt.email);
      }
      return '';
    }
    var ORDEM = ['cnpj', 'razao', 'tipo', 'cidade', 'uf', 'fone', 'email'];
    function validarTudo() {
      var primeiro = null;
      ORDEM.forEach(function (k) {
        var msg = erroDe(k);
        mostrarErro(k, msg);
        if (msg && !primeiro) primeiro = k === 'tipo' ? (radios[0] || null) : c[k];
      });
      return primeiro;
    }

    // Valida ao sair do campo (se a pessoa mexeu nele) e tira o erro assim que o valor fica certo.
    ['razao', 'cidade', 'uf', 'fone', 'email', 'cnpj'].forEach(function (k) {
      var el = c[k];
      if (!el) return;
      el.addEventListener('blur', function () {
        if (el.value.trim() || el.hasAttribute('data-mexeu')) mostrarErro(k, erroDe(k));
      });
      el.addEventListener('input', function (ev) {
        el.setAttribute('data-mexeu', '');
        if (ev.isTrusted) el.removeAttribute('data-auto');
        if (el.getAttribute('aria-invalid') === 'true' && !erroDe(k)) mostrarErro(k, '');
      });
      el.addEventListener('change', function () { if (el.getAttribute('aria-invalid') === 'true' && !erroDe(k)) mostrarErro(k, ''); });
    });
    radios.forEach(function (r) { r.addEventListener('change', function () { mostrarErro('tipo', ''); }); });

    /* ---------- máscaras ---------- */
    c.fone && c.fone.addEventListener('input', function () { mascarar(c.fone, foneMascara, soDigitos); });

    var consultado = '';
    c.cnpj.addEventListener('input', function () {
      mascarar(c.cnpj, cnpjMascara, cnpjLimpo);
      var v = cnpjLimpo(c.cnpj.value);
      if (v.length < 14) { if (consultado) { consultado = ''; mostrarStatus('', ''); } return; }
      if (!cnpjValido(v)) { mostrarStatus('', ''); mostrarErro('cnpj', txt.cnpj); return; }
      mostrarErro('cnpj', '');
      consultar(v);
    });

    /* ---------- consulta pública do CNPJ (BrasilAPI) ---------- */
    function preencherAuto(el, valor) {
      if (!el || !valor) return;
      if (el.value.trim() && el.getAttribute('data-auto') !== '1') return;   // a pessoa já escreveu: fica o dela
      if (el.tagName === 'SELECT' && !el.querySelector('option[value="' + valor + '"]')) return;
      el.value = valor;
      el.setAttribute('data-auto', '1');
      mostrarErro(el.getAttribute('data-r130-lp-campo'), '');
    }
    function consultar(v) {
      if (v === consultado) return;
      consultado = v;
      if (!window.fetch) return;
      mostrarStatus('busca', txt.cnpj_buscando);
      var ctrl = window.AbortController ? new AbortController() : null;
      var tempo = setTimeout(function () { if (ctrl) ctrl.abort(); }, 7000);
      fetch(API + v, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (d) {
          clearTimeout(tempo);
          if (cnpjLimpo(c.cnpj.value) !== v) return;
          if (!d || !d.razao_social) throw new Error('sem dados');
          preencherAuto(c.razao, String(d.razao_social).trim());
          preencherAuto(c.cidade, tituloCidade(d.municipio));
          preencherAuto(c.uf, String(d.uf || '').toUpperCase());
          var sit = String(d.descricao_situacao_cadastral || '').toUpperCase();
          if (sit && sit !== 'ATIVA') mostrarStatus('aviso', txt.cnpj_inativo);
          else mostrarStatus('ok', txt.cnpj_ok);
        })
        .catch(function () {
          clearTimeout(tempo);
          if (cnpjLimpo(c.cnpj.value) !== v) return;
          mostrarStatus('aviso', txt.cnpj_sem_dados);
        });
    }

    /* ---------- teclado do CNPJ: números ou letras ---------- */
    if (troca) {
      troca.hidden = false;
      troca.addEventListener('click', function () {
        var paraLetras = c.cnpj.getAttribute('inputmode') !== 'text';
        c.cnpj.setAttribute('inputmode', paraLetras ? 'text' : 'numeric');
        troca.textContent = troca.getAttribute(paraLetras ? 'data-txt-numeros' : 'data-txt-letras');
        c.cnpj.focus();
      });
    }

    /* ---------- consentimento de marketing (separado, opcional) ---------- */
    if (mkt && mktValor) mkt.addEventListener('change', function () { mktValor.value = mkt.checked ? 'Sim' : 'Não'; });

    /* ---------- mensagem do WhatsApp ---------- */
    function dados() {
      var t = tipoMarcado();
      return {
        razao: c.razao.value.trim(),
        cnpj: cnpjMascara(c.cnpj.value),
        tipo: t ? t.getAttribute('data-tipo') : '',
        tipoTexto: t ? t.value : '',
        cidade: c.cidade.value.trim(),
        uf: c.uf.value,
        procura: c.procura ? c.procura.value.trim() : ''
      };
    }
    function montarMensagem(d) {
      var mapa = { razao: d.razao, cnpj: d.cnpj, tipo: d.tipoTexto, cidade: d.cidade, uf: d.uf, procura: d.procura };
      var linhas = [];
      String(cfg.msg || '').split(/\r?\n/).forEach(function (l) {
        var vazio = false;
        var r = l.replace(/\{(\w+)\}/g, function (m, k) {
          if (!Object.prototype.hasOwnProperty.call(mapa, k)) return m;
          var val = String(mapa[k] || '').trim();
          if (!val) vazio = true;
          return val;
        });
        if (!vazio) linhas.push(r);
      });
      var msg = linhas.join('\n').trim();
      // O r130-chassi.js já faz isso para o número da loja; aqui vale também para o número de um vendedor.
      var vin = chassiSalvo();
      if (vin && msg.indexOf(vin) === -1) msg += '\n\nChassi: ' + vin;
      return msg;
    }
    function urlWhats(msg) { return 'https://wa.me/' + String(cfg.fone || '').replace(/\D/g, '') + '?text=' + encodeURIComponent(msg); }

    /* ---------- envio ---------- */
    form.addEventListener('submit', function (ev) {
      if (form.getAttribute('data-enviando') === '1') { ev.preventDefault(); return; }
      var primeiro = validarTudo();
      if (primeiro) {
        ev.preventDefault();
        if (resumo) { resumo.hidden = false; resumo.lastChild.textContent = txt.resumo || ''; }
        // Foco no 1º campo com erro, no meio da tela (no celular a barra fixa de baixo cobriria o campo).
        try { primeiro.focus({ preventScroll: true }); } catch (e) { primeiro.focus(); }
        try { primeiro.scrollIntoView({ block: 'center' }); } catch (e) {}
        return;
      }
      if (resumo) resumo.hidden = true;
      var d = dados();
      var msg = montarMensagem(d);
      var url = urlWhats(msg);
      if (tags) tags.value = 'lead-b2b, tipo:' + d.tipo;
      if (msgCampo) msgCampo.value = msg;
      if (mkt && mktValor) mktValor.value = mkt.checked ? 'Sim' : 'Não';
      gravarSessao({
        url: url,
        campos: { cnpj: c.cnpj.value, razao: c.razao.value, tipo: d.tipo, cidade: c.cidade.value, uf: c.uf.value,
                  fone: c.fone.value, email: c.email.value, procura: c.procura ? c.procura.value : '', mkt: !!(mkt && mkt.checked) }
      });
      try { document.dispatchEvent(new CustomEvent('r130:lead-b2b', { detail: { tipo: d.tipo, origem: cfg.origem || 'lp-oficinas-e-lojas' } })); } catch (e) {}
      // Abre o WhatsApp no mesmo toque (sem isso o navegador bloqueia a janela); o formulário segue nesta aba.
      try { window.open(url, '_blank', 'noopener'); } catch (e) {}
      form.setAttribute('data-enviando', '1');
      botao.setAttribute('aria-busy', 'true');
      var rot = botao.querySelector('span');
      if (rot && botao.getAttribute('data-txt-enviando')) rot.textContent = botao.getAttribute('data-txt-enviando');
    });

    // Para testes e para o agente de medição: as mesmas regras do navegador, sem enviar nada.
    form.r130lp = { cnpjValido: cnpjValido, foneValido: foneValido, montarMensagem: montarMensagem, dados: dados, urlWhats: urlWhats };
  }

  // Voltou pelo botão "voltar" com a página guardada na memória do navegador: libera o botão de novo.
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-r130-lp-form][data-enviando]'), function (f) {
      f.removeAttribute('data-enviando');
      var b = f.querySelector('[data-r130-lp-enviar]');
      if (b) b.removeAttribute('aria-busy');
    });
  });

  function rodar() { Array.prototype.forEach.call(document.querySelectorAll('[data-r130-lp-form]'), iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rodar); else rodar();
})();
